import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { TypoText } from "ui/Typo";

interface SectionProps {
    uiData: IFormInputs;
}

export default function Section({ uiData }: SectionProps) {
    const title = uiData?.description;
    const description = uiData?.elements?.[0]?.description;

    return <Fieldset title={title}>{description && <TypoText>{description}</TypoText>}</Fieldset>;
}
